import { DotBadge } from '@backrs_ui/common-ui';

import { RelevanceRating, RELEVANCE_COLORS } from '../types';

/**
 * Props for the RelevanceBadge component
 */
export interface RelevanceBadgeProps {
  /** Relevance level to display */
  level: RelevanceRating;
  /** Whether the badge is interactive (clickable with hover/focus states) */
  interactive?: boolean;
  /** Whether the badge is in active state (only applies when interactive) */
  isActive?: boolean;
  /** Click handler (only applies when interactive) */
  onClick?: () => void;
  id?: string;
}

/**
 * Relevance-level badge: the shared `DotBadge` atom keyed to a relevance rating.
 */
export const RelevanceBadge = ({
  level,
  interactive = false,
  isActive = true,
  onClick,
  id,
}: RelevanceBadgeProps) => (
  <DotBadge
    id={id}
    label={level}
    dotColor={RELEVANCE_COLORS[level]}
    interactive={interactive}
    isActive={isActive}
    onClick={onClick}
  />
);
